const COMMON_CONST = {
	INIT: 'INIT',
	SCROLL: 'SCROLL'
};

export default COMMON_CONST;
